<template>
  <div class="box tab-box">
	  <div class="header">
		  <div class="tab-btn" v-for="(tab,i) in tabs">Tab btn: {{tab.label}} {{i}}</div>
	  </div>
    <template v-for="(tab,i) in tabs">
      <slot :name="'tab'+i+i"></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Tab-Boxes',
  props: ['tabs']
}
</script>

<style lang="scss">
	@import '../styling/global_vars';



</style>



// WEBPACK FOOTER //
// TabBoxes.vue?669937aa